<div
  [value]="data | cellValue"
  [appAction]="meta | cellAction: row"
  [appCellStyles]="meta?.styleClasses"
  [appAlerter]="meta?.alerter">

  <ng-container appContent></ng-container>

</div>

<ng-template
  #text
  let-text="text">

  <span [innerHTML]="text"></span>

</ng-template>

<ng-template
  #icon
  let-icon="icon">

  <sd-4-5-1-icon
    class="table-data-icon"
    library="{{ iconLibrary }}"
    [name]="icon"></sd-4-5-1-icon>

</ng-template>

<ng-template #br>
  <app-table-cell-linebreak/>
</ng-template>
